import { useEffect, useRef } from 'react';

export const useRegisterCellRef = ({ cellRefs, cellKey }) => {
  const cellRef = useRef(null);

  useEffect(() => {
    if (!cellRefs?.register || !cellKey) return undefined;

    if (cellRef.current) {
      const refObj = { current: cellRef.current };
      cellRefs.register(cellKey, refObj);
    }

    return () => {
      cellRefs.register(cellKey, null);
    };
  }, [cellRefs, cellKey]);

  return cellRef;
};
